 (function ($) {
	$.preloadVideo = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			preloadVideo = (function ($c, o) {
				var defaults = {
					'video' : $c.find('video')[0],
					'breakpoint' : 900
				}; 

				var _o = {},
					$preloadVideo = null
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
				},

				_CheckWidth = function () {
					if ($(window).width() > _o.breakpoint) {
						_Preload();
						_BindLoadedEvent();
					}
				},

				_Preload = function () {	
					_o.video.load();
				},

				_HideImage = function () {
					$('.preload-img').fadeOut(200);
				},

				_BindLoadedEvent = function () {
					_o.video.oncanplaythrough = function() {
						_o.video.play();
						_HideImage();
					}
				},

				_BindEvents = function () {

				},

				init = (function() {
					_InitObjects();
					_BindEvents();
					_CheckWidth();
				})();
			}) ($c, options);
	};

	$.fn.preloadVideo = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('preloadVideo')) {
				var plugin = new $.preloadVideo(this, options);
				$(this).data('preloadVideo', plugin);
			}
		});
	};
})(jQuery);



